module.exports = __webpack_public_path__ + "static/img/contact-info-icon-1.b08e26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact-info-icon-1.png
// module id = 1L2X
// module chunks = 0